module.exports = __webpack_public_path__ + "img/separatePage.4a967fdf.gif";